module.exports = __webpack_public_path__ + "img/login1.ea1ac92e.svg";